module.exports = __webpack_public_path__ + "media/images/check-small-392ba813.svg";